import React from 'react'
import { UserInfo } from '../../../interfaces/user';

interface UserProfileSectionProps {
  userInfo: UserInfo | null;
}

interface CardData {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  onPress: () => void;
}

const UserProfileSection: React.FC<UserProfileSectionProps> = ({ userInfo }) => {
  return (
    <div>

    </div>
  )
}

export default UserProfileSection
